module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_06-cab454c69d28bbac7248b41fc773f8cd.jpg";